export default function digitalClock() {
    const clockElement = document.querySelector('.gh-clock');

    if (!clockElement) return;

    function updateTime() {
        const now = new Date();
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        clockElement.textContent = `${hours}:${minutes}`;
    }

    // Update immediately and then every second
    updateTime();
    setInterval(updateTime, 1000);
}
